




import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import {
    getAllDeliverySettlementsAPI,
    getDeliverySettlementByIdAPI,
    checkAdminWalletBalanceAPI,
    updateDeliverySettlementStatusAPI,
} from "../../../Servicefile/LogisticService.jsx";

// ============================================
// PREMIUM ICONS COMPONENT
// ============================================
const Icons = {
    Search: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" />
        </svg>
    ),
    Export: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
    ),
    Clear: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Filter: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polygon points="22 3 2 3 10 13 10 21 14 18 14 13 22 3" />
        </svg>
    ),
    Calendar: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
    ),
    Money: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0b5e42" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M8 12h8" />
            <path d="M12 8v8" />
        </svg>
    ),
    Vendor: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
        </svg>
    ),
    Bank: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="6" width="20" height="14" rx="2" />
            <path d="M2 10h20" />
            <path d="M8 14v4" />
            <path d="M12 14v4" />
            <path d="M16 14v4" />
        </svg>
    ),
    Status: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
        </svg>
    ),
    NoData: () => (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
            <rect x="2" y="3" width="20" height="18" rx="2" />
            <line x1="8" y1="21" x2="16" y2="21" />
            <line x1="12" y1="17" x2="12" y2="21" />
            <path d="M8 7h8M8 11h6M8 15h4" />
        </svg>
    ),
    Close: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Edit: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
    ),
    Refresh: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M23 4v6h-6M1 20v-6h6" />
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
        </svg>
    ),
    Settlement: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgb(230 109 51)" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M8 12h8" />
            <path d="M12 8v8" />
        </svg>
    ),
    Partner: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
    ),
    Wallet: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
            <line x1="1" y1="10" x2="23" y2="10" />
        </svg>
    ),
    CheckCircle: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#28a745" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
    ),
    Clock: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ffc107" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
        </svg>
    ),
    Building: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
            <line x1="9" y1="22" x2="15" y2="22" />
            <line x1="9" y1="6" x2="15" y2="6" />
            <line x1="9" y1="10" x2="15" y2="10" />
            <line x1="9" y1="14" x2="15" y2="14" />
        </svg>
    ),
    User: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
        </svg>
    ),
    TrendingUp: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
            <polyline points="17 6 23 6 23 12" />
        </svg>
    ),
    TrendingDown: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="23 18 13.5 8.5 8.5 13.5 1 6" />
            <polyline points="17 18 23 18 23 12" />
        </svg>
    ),
    UPI: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2196F3" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M8 12h8" />
            <path d="M12 8v8" />
        </svg>
    )
};

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    settlementContainer: {
        padding: '11px 5px',
        width: '100%',
        maxWidth: '100%',
        overflowX: 'hidden'
    },
    settlementHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 0 16px 0',
        borderBottom: '2px solid #e9ecef',
        flexWrap: 'wrap',
        gap: '12px'
    },
    settlementTitle: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    settlementTitleBadge: {
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    settlementStatsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
        gap: '14px',
        marginBottom: '16px',
        padding: '18px',
        background: 'white',
        borderRadius: '14px',
        border: '1px solid #edf2f7',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
    },
    settlementStatCard: {
        textAlign: 'center',
        padding: '8px 4px',
        borderRadius: '10px',
        transition: 'all 0.3s ease',
        cursor: 'default'
    },
    settlementStatValue: {
        fontSize: '26px',
        fontWeight: '700',
        color: '#2d3748',
        lineHeight: '1.2'
    },
    settlementStatLabel: {
        fontSize: '12px',
        color: '#718096',
        fontWeight: '500',
        textTransform: 'uppercase',
        letterSpacing: '0.4px',
        marginTop: '4px'
    },
    settlementFilters: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '10px',
        padding: '12px 0',
        borderBottom: '1px solid #edf2f7',
        marginBottom: '16px'
    },
    settlementSearchGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flex: '1 1 auto',
        minWidth: '280px'
    },
    settlementSelect: {
        padding: '8px 12px',
        border: '2px solid #e2e8f0',
        borderRadius: '10px',
        background: 'white',
        fontSize: '13px',
        fontWeight: '500',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.3s ease',
        height: '42px',
        minWidth: '140px',
        cursor: 'pointer'
    },
    settlementSearchInput: {
        flex: '1',
        padding: '8px 14px 8px 38px',
        border: '2px solid #e2e8f0',
        borderRadius: '10px',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.3s ease',
        height: '42px',
        background: 'white',
        minWidth: '180px'
    },
    settlementDateInput: {
        padding: '8px 14px',
        border: '2px solid #e2e8f0',
        borderRadius: '10px',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.3s ease',
        height: '42px',
        background: 'white',
        minWidth: '150px'
    },
    settlementButton: {
        padding: '8px 18px',
        borderRadius: '10px',
        border: 'none',
        fontWeight: '600',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        height: '42px',
        whiteSpace: 'nowrap'
    },
    settlementButtonPrimary: {
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        color: 'white',
        boxShadow: '0 4px 15px rgba(230, 109, 51, 0.3)'
    },
    settlementButtonSecondary: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    settlementButtonExport: {
        background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
        color: 'white',
        boxShadow: '0 4px 15px rgba(40, 167, 69, 0.3)'
    },
    settlementTableWrapper: {
        borderRadius: '12px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflow: 'auto',
        maxHeight: '60vh',
        position: 'relative',
        width: '100%',
        maxWidth: '100%'
    },
    settlementTable: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '1400px'
    },
    settlementTableHead: {
        position: 'sticky',
        top: 0,
        zIndex: 10
    },
    settlementTableHeader: {
        padding: '10px 12px',
        textAlign: 'center',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        borderBottom: '2px solid #d45a1a',
        whiteSpace: 'nowrap'
    },
    settlementTableCell: {
        padding: '10px 12px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '13px',
        textAlign: 'center',
        verticalAlign: 'middle'
    },
    settlementBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '3px 12px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: '600',
        letterSpacing: '0.3px'
    },
    settlementBadgePaid: {
        background: '#c6f6d5',
        color: '#276749'
    },
    settlementBadgePending: {
        background: '#fefcbf',
        color: '#975a16'
    },
    settlementBadgeRejected: {
        background: '#f8d7da',
        color: '#721c24'
    },
    settlementBadgeCompleted: {
        background: '#c6f6d5',
        color: '#276749'
    },
    settlementBadgeDefault: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    settlementEmptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        color: '#a0aec0'
    },
    settlementEmptyStateText: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#4a5568'
    },
    settlementEmptyStateSubtext: {
        fontSize: '13px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    settlementModalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        backdropFilter: 'blur(4px)',
        padding: '20px'
    },
    settlementModal: {
        background: 'white',
        borderRadius: '16px',
        padding: '28px',
        width: '560px',
        maxWidth: '95%',
        maxHeight: '85vh',
        scrollbarWidth: 'none',
        overflowY: 'auto',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        animation: 'settlementSlideUp 0.3s ease'
    },
    settlementModalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingBottom: '16px',
        borderBottom: '2px solid #f0f0f0',
        marginBottom: '20px'
    },
    settlementModalTitle: {
        fontSize: '20px',
        fontWeight: '700',
        color: '#1a1a2e',
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    settlementModalClose: {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: '#a0aec0',
        transition: 'all 0.3s ease',
        padding: '4px'
    },
    settlementModalBody: {
        padding: '0 0 4px 0'
    },
    settlementFormRow: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '16px',
        marginBottom: '16px'
    },
    settlementFormGroup: {
        marginBottom: '16px'
    },
    settlementFormGroupFull: {
        marginBottom: '16px',
        gridColumn: '1 / -1'
    },
    settlementLabel: {
        display: 'block',
        marginBottom: '6px',
        fontSize: '13px',
        fontWeight: '600',
        color: '#4a5568'
    },
    settlementReadOnlyInput: {
        width: '100%',
        padding: '10px 14px',
        borderRadius: '8px',
        border: '2px solid #edf2f7',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        background: '#f7fafc',
        cursor: 'not-allowed',
        boxSizing: 'border-box'
    },
    settlementTextarea: {
        width: '100%',
        padding: '10px 14px',
        borderRadius: '8px',
        border: '2px solid #e2e8f0',
        fontSize: '13px',
        outline: 'none',
        transition: 'all 0.3s ease',
        resize: 'vertical',
        boxSizing: 'border-box',
        fontFamily: 'inherit'
    },
    settlementModalFooter: {
        display: 'flex',
        gap: '10px',
        paddingTop: '16px',
        borderTop: '2px solid #f0f0f0',
        marginTop: '4px'
    },
    settlementAmount: {
        fontWeight: '600',
        color: '#0b5e42'
    },
    settlementRemarksCell: {
        maxWidth: '150px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        cursor: 'pointer',
        color: '#4a5568'
    },
    settlementPaymentMode: {
        display: 'inline-block',
        padding: '2px 10px',
        borderRadius: '4px',
        fontSize: '11px',
        fontWeight: '600'
    },

    // Partner Dashboard Card Styles
    partnerDashboardGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: '20px',
        marginBottom: '20px'
    },
    partnerCard: {
        background: 'white',
        borderRadius: '16px',
        border: '1px solid #edf2f7',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
        overflow: 'hidden',
        transition: 'all 0.3s ease'
    },
    partnerCardHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '16px 24px',
        background: 'linear-gradient(135deg, #e66d33 0%, #e66d33 100%)',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        flexWrap: 'wrap',
        gap: '12px'
    },
    partnerCardHeaderLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: '14px'
    },
    partnerAvatar: {
        width: '48px',
        height: '48px',
        borderRadius: '50%',
        background: 'rgba(255,255,255,0.2)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '24px',
        color: 'white',
        backdropFilter: 'blur(10px)'
    },
    partnerHeaderInfo: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px'
    },
    partnerHeaderName: {
        margin: 0,
        fontSize: '18px',
        fontWeight: '700',
        color: 'white'
    },
    partnerHeaderId: {
        fontSize: '12px',
        color: 'white'
    },
    partnerHeaderRight: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        flexWrap: 'wrap'
    },
    partnerHeaderStat: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '4px 12px',
        borderRadius: '12px',
        background: 'rgba(255,255,255,0.15)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500'
    },
    partnerHeaderStatPaid: {
        background: 'white',
        color: '#e66d33'
    },
    partnerHeaderStatPending: {
        background: 'white',
        color: '#e66d33'
    },
    partnerHeaderStatRejected: {
        background: 'white',
        color: '#ff6b6b'
    },
    expandIcon: {
        color: 'white',
        fontSize: '20px',
        fontWeight: '700',
        marginLeft: '5px',
        transition: 'transform 0.3s ease'
    },
    expandIconRotated: {
        transform: 'rotate(180deg)'
    },

    // Partner Dashboard Body
    partnerDashboardBody: {
        padding: '20px 24px 24px 24px',
        animation: 'slideDown 0.3s ease'
    },

    // KPI Cards Grid
    kpiGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: '14px',
        marginBottom: '20px'
    },
    kpiCard: {
        background: '#f8f9fa',
        borderRadius: '12px',
        padding: '16px',
        border: '1px solid #edf2f7',
        transition: 'all 0.3s ease'
    },
    kpiLabel: {
        fontSize: '11px',
        fontWeight: '600',
        color: '#718096',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        marginBottom: '6px'
    },
    kpiValue: {
        fontSize: '24px',
        fontWeight: '700',
        color: '#2d3748'
    },
    kpiSubtext: {
        fontSize: '12px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    kpiIcon: {
        fontSize: '20px',
        marginBottom: '4px'
    },

    // Partner Details Section
    partnerDetailsGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '16px',
        marginBottom: '20px'
    },
    partnerDetailCard: {
        background: '#f8f9fa',
        borderRadius: '12px',
        padding: '16px',
        border: '1px solid #edf2f7'
    },
    partnerDetailTitle: {
        fontSize: '13px',
        fontWeight: '600',
        color: '#4a5568',
        marginBottom: '10px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    },
    partnerDetailRow: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '6px 0',
        borderBottom: '1px solid #e9ecef',
        fontSize: '13px'
    },
    partnerDetailRowLast: {
        borderBottom: 'none'
    },
    partnerDetailLabel: {
        color: '#718096'
    },
    partnerDetailValue: {
        fontWeight: '500',
        color: '#2d3748'
    },

    // Settlement Items Table inside Partner Card
    partnerSettlementTable: {
        width: '100%',
        fontSize: '12px',
        borderCollapse: 'collapse',
        marginTop: '10px'
    },
    partnerSettlementHeader: {
        padding: '8px 10px',
        textAlign: 'left',
        fontWeight: '600',
        fontSize: '10px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: '#718096',
        borderBottom: '2px solid #edf2f7'
    },
    partnerSettlementCell: {
        padding: '8px 10px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '12px'
    },
    partnerSettlementAction: {
        padding: '4px 12px',
        borderRadius: '6px',
        border: 'none',
        fontWeight: '600',
        fontSize: '11px',
        cursor: 'pointer',
        transition: 'all 0.3s ease'
    },

    // Date Filter Section
    dateFilterSection: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '10px',
        padding: '12px 16px',
        background: '#f8f9fa',
        borderRadius: '10px',
        marginBottom: '16px',
        border: '1px solid #edf2f7'
    },
    dateFilterButton: {
        padding: '6px 16px',
        borderRadius: '20px',
        border: '2px solid #e2e8f0',
        background: 'white',
        fontSize: '12px',
        fontWeight: '500',
        color: '#4a5568',
        cursor: 'pointer',
        transition: 'all 0.3s ease'
    },
    dateFilterButtonActive: {
        borderColor: '#e66d33',
        background: '#e66d33',
        color: 'white'
    },
    dateFilterDivider: {
        color: '#e2e8f0',
        fontSize: '18px',
        fontWeight: '300'
    },

    // Payment Type Badge
    paymentTypeUPI: {
        background: '#2196F3',
        color: 'white'
    },
    paymentTypeBank: {
        background: '#4CAF50',
        color: 'white'
    },
    paymentTypeNEFT: {
        background: '#9C27B0',
        color: 'white'
    },
    paymentTypeRTGS: {
        background: '#FF9800',
        color: 'white'
    },
    paymentTypeDefault: {
        background: '#9E9E9E',
        color: 'white'
    }
};

// ============================================
// PARTNER DASHBOARD CARD COMPONENT
// ============================================
const PartnerDashboardCard = ({ partnerId, partnerData, onUpdateStatus }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [selectedSettlement, setSelectedSettlement] = useState(null);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [newStatus, setNewStatus] = useState("");
    const [transactionId, setTransactionId] = useState("");
    const [amount, setAmount] = useState("");
    const [walletBalance, setWalletBalance] = useState(null);
    const [checkingBalance, setCheckingBalance] = useState(false);
    const { showLoader, hideLoader } = useLoader();

    const toggleExpand = () => setIsExpanded(!isExpanded);

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount || 0);
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toISOString().split('T')[0];
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return '-';
        try {
            const date = new Date(dateString);
            return date.toLocaleString();
        } catch (error) {
            return dateString;
        }
    };

    const getStatusBadge = (status) => {
        if (!status) return styles.settlementBadgeDefault;
        if (status === "PAID" || status === "COMPLETED") return styles.settlementBadgeCompleted;
        if (status === "PENDING") return styles.settlementBadgePending;
        if (status === "REJECTED") return styles.settlementBadgeRejected;
        return styles.settlementBadgeDefault;
    };

    const getPaymentTypeStyle = (type) => {
        switch (type) {
            case "UPI": return styles.paymentTypeUPI;
            case "BANK_TRANSFER": return styles.paymentTypeBank;
            case "NEFT": return styles.paymentTypeNEFT;
            case "RTGS": return styles.paymentTypeRTGS;
            default: return styles.paymentTypeDefault;
        }
    };

    // Calculate KPIs
    const totalSettlements = partnerData.length;
    const totalAmount = partnerData.reduce((sum, item) => sum + (item.withdrawlAmount || 0), 0);
    const completedCount = partnerData.filter(item => item.settlementStatus === "COMPLETED" || item.settlementStatus === "PAID").length;
    const pendingCount = partnerData.filter(item => item.settlementStatus === "PENDING").length;
    const rejectedCount = partnerData.filter(item => item.settlementStatus === "REJECTED").length;

    // Generate Transaction ID
    const generateTransactionId = () => {
        const timestamp = Date.now();
        const randomNum = Math.floor(Math.random() * 10000);
        return `TXN_${timestamp}_${randomNum}`;
    };

    // Check Admin Wallet Balance
    const checkAdminWalletBalance = async () => {
        try {
            setCheckingBalance(true);
            const balance = await checkAdminWalletBalanceAPI();
            setWalletBalance(balance);
            alert(`Admin Wallet Balance: ₹${balance.toFixed(2)}`);
        } catch (err) {
            console.error("Error fetching wallet balance:", err);
            alert("Unable to fetch wallet balance. Please contact support.");
        } finally {
            setCheckingBalance(false);
        }
    };

    const handleStatusUpdateClick = (settlement) => {
        setSelectedSettlement(settlement);
        setNewStatus(settlement.settlementStatus || "PENDING");
        setTransactionId(settlement.transactionId || "");
        setAmount(settlement.withdrawlAmount || "");
        setWalletBalance(null);
        setShowUpdateModal(true);
    };

    const handleUpdateStatus = async () => {
        if (!selectedSettlement) {
            alert("Please select a settlement");
            return;
        }

        if (!amount || isNaN(amount) || parseFloat(amount) <= 0) {
            alert("Please enter a valid amount");
            return;
        }

        if (!transactionId || transactionId.trim() === "") {
            setTransactionId(generateTransactionId());
            alert("Transaction ID generated automatically: " + transactionId);
            return;
        }

        try {
            showLoader();
            const settlementId = selectedSettlement.id;
            const updateAmount = parseFloat(amount);

            const result = await updateDeliverySettlementStatusAPI({
                settlementId,
                amount: updateAmount,
                transactionId,
            });

            if (result.success || result.message || result.id) {
                alert("Settlement status updated successfully!");
                onUpdateStatus();
                setShowUpdateModal(false);
                setSelectedSettlement(null);
                setNewStatus("");
                setTransactionId("");
                setAmount("");
                setWalletBalance(null);
            } else {
                alert(`Failed to update status: ${JSON.stringify(result)}`);
            }
        } catch (err) {
            console.error("Error updating settlement status:", err);
            const errorMessage = err.response?.data?.message || err.response?.data?.error || err.message || "Failed to update status";
            alert(`❌ Failed to update status: ${errorMessage}`);
        } finally {
            hideLoader();
        }
    };

    return (
        <>
            <div style={styles.partnerCard}>
                {/* Partner Card Header - Click to Expand */}
                <div style={styles.partnerCardHeader} onClick={toggleExpand}>
                    <div style={styles.partnerCardHeaderLeft}>
                        <div style={styles.partnerAvatar}>
                            {partnerData[0]?.partnerLogo || '👤'}
                        </div>
                        <div style={styles.partnerHeaderInfo}>
                            <h3 style={styles.partnerHeaderName}>
                                {partnerData[0]?.partnerAccountHolderName || partnerId}
                            </h3>
                            <div style={styles.partnerHeaderId}>
                                Partner ID: {partnerId}
                            </div>
                            <div style={styles.partnerHeaderId}>
                                UPI: {partnerData[0]?.partnerUpiId || 'N/A'}
                            </div>
                        </div>
                    </div>
                    <div style={styles.partnerHeaderRight}>
                        <span style={{ ...styles.partnerHeaderStat, ...styles.partnerHeaderStatPending }}>
                            <Icons.Clock /> {pendingCount} Pending
                        </span>
                        <span style={{ ...styles.partnerHeaderStat, ...styles.partnerHeaderStatPaid }}>
                            <Icons.CheckCircle /> {completedCount} Completed
                        </span>
                        {rejectedCount > 0 && (
                            <span style={{ ...styles.partnerHeaderStat, ...styles.partnerHeaderStatRejected }}>
                                ❌ {rejectedCount} Rejected
                            </span>
                        )}
                        <span style={{ ...styles.partnerHeaderStat }}>
                            <Icons.Money /> {(totalAmount)}
                        </span>
                        <span style={{
                            ...styles.expandIcon,
                            ...(isExpanded ? styles.expandIconRotated : {})
                        }}>
                            ▼
                        </span>
                    </div>
                </div>

                {/* Expanded Content - Partner Dashboard */}
                {isExpanded && (
                    <div style={styles.partnerDashboardBody}>
                        {/* KPI Cards Grid */}
                        <div style={styles.kpiGrid}>
                            <div style={styles.kpiCard}>
                                <div style={styles.kpiIcon}>📊</div>
                                <div style={styles.kpiLabel}>Total Settlements</div>
                                <div style={styles.kpiValue}>{totalSettlements}</div>
                            </div>
                            <div style={styles.kpiCard}>
                                <div style={styles.kpiIcon}>💰</div>
                                <div style={styles.kpiLabel}>Total Amount</div>
                                <div style={styles.kpiValue}>{(totalAmount)}</div>
                            </div>
                            <div style={styles.kpiCard}>
                                <div style={styles.kpiIcon}>✅</div>
                                <div style={styles.kpiLabel}>Completed</div>
                                <div style={styles.kpiValue}>{completedCount}</div>
                                <div style={styles.kpiSubtext}>{(totalAmount * (completedCount / (totalSettlements || 1)))}</div>
                            </div>
                            <div style={styles.kpiCard}>
                                <div style={styles.kpiIcon}>⏳</div>
                                <div style={styles.kpiLabel}>Pending</div>
                                <div style={styles.kpiValue}>{pendingCount}</div>
                                <div style={styles.kpiSubtext}>{(totalAmount * (pendingCount / (totalSettlements || 1)))}</div>
                            </div>
                            {rejectedCount > 0 && (
                                <div style={styles.kpiCard}>
                                    <div style={styles.kpiIcon}>❌</div>
                                    <div style={styles.kpiLabel}>Rejected</div>
                                    <div style={styles.kpiValue}>{rejectedCount}</div>
                                </div>
                            )}
                        </div>

                        {/* Partner Details */}
                        <div style={styles.partnerDetailsGrid}>
                            <div style={styles.partnerDetailCard}>
                                <div style={styles.partnerDetailTitle}>
                                    <Icons.User /> Partner Details
                                </div>
                                <div style={styles.partnerDetailRow}>
                                    <span style={styles.partnerDetailLabel}>Account Holder</span>
                                    <span style={styles.partnerDetailValue}>{partnerData[0]?.partnerAccountHolderName || '-'}</span>
                                </div>
                                <div style={styles.partnerDetailRow}>
                                    <span style={styles.partnerDetailLabel}>UPI ID</span>
                                    <span style={styles.partnerDetailValue}>{partnerData[0]?.partnerUpiId || '-'}</span>
                                </div>
                                <div style={styles.partnerDetailRow}>
                                    <span style={styles.partnerDetailLabel}>Payment Type</span>
                                    <span style={styles.partnerDetailValue}>{partnerData[0]?.paymentType || 'UPI'}</span>
                                </div>
                            </div>
                            <div style={styles.partnerDetailCard}>
                                <div style={styles.partnerDetailTitle}>
                                    <Icons.Bank /> Bank Details
                                </div>
                                <div style={styles.partnerDetailRow}>
                                    <span style={styles.partnerDetailLabel}>Bank Account</span>
                                    <span style={styles.partnerDetailValue}>{partnerData[0]?.partnerBankAccountNumber || '-'}</span>
                                </div>
                                <div style={styles.partnerDetailRow}>
                                    <span style={styles.partnerDetailLabel}>IFSC Code</span>
                                    <span style={styles.partnerDetailValue}>{partnerData[0]?.partnerIfscCode || '-'}</span>
                                </div>
                                <div style={{ ...styles.partnerDetailRow, ...styles.partnerDetailRowLast }}>
                                    <span style={styles.partnerDetailLabel}>Bank Name</span>
                                    <span style={styles.partnerDetailValue}>{partnerData[0]?.partnerBankName || '-'}</span>
                                </div>
                            </div>
                        </div>

                        {/* Settlement Items Table */}
                        <div style={{ ...styles.partnerDetailCard, padding: '0', background: 'white' }}>
                            <div style={{ ...styles.partnerDetailTitle, padding: '16px 16px 0 16px' }}>
                                <Icons.Settlement /> Settlement History
                            </div>
                            <div style={{ overflowX: 'auto' }}>
                                <table style={styles.partnerSettlementTable}>
                                    <thead>
                                        <tr>
                                            <th style={styles.partnerSettlementHeader}>#</th>
                                            <th style={styles.partnerSettlementHeader}>Settlement ID</th>
                                            <th style={styles.partnerSettlementHeader}>Amount</th>
                                            <th style={styles.partnerSettlementHeader}>Request Date</th>
                                            <th style={styles.partnerSettlementHeader}>Settle Date</th>
                                            <th style={styles.partnerSettlementHeader}>Payment Type</th>
                                            <th style={styles.partnerSettlementHeader}>Transaction ID</th>
                                            <th style={styles.partnerSettlementHeader}>Status</th>
                                            <th style={styles.partnerSettlementHeader}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {partnerData.map((item, index) => (
                                            <tr key={item.id || index}>
                                                <td style={styles.partnerSettlementCell}>{index + 1}</td>
                                                <td style={{ ...styles.partnerSettlementCell, fontFamily: 'monospace', fontSize: '11px' }}>
                                                    {item.id}
                                                </td>
                                                <td style={{ ...styles.partnerSettlementCell, fontWeight: '600', color: '#0b5e42' }}>
                                                    {(item.withdrawlAmount)}
                                                </td>
                                                <td style={styles.partnerSettlementCell}>
                                                    {item.settlementRequestDate
                                                        ? new Date(item.settlementRequestDate)
                                                            .toLocaleDateString("en-GB")
                                                            .replace(/\//g, "-")
                                                        : "N/A"}
                                                </td>
                                                <td style={styles.partnerSettlementCell}>{item.settlementDate || '-'}</td>
                                                <td style={styles.partnerSettlementCell}>
                                                    <span style={{
                                                        ...styles.settlementPaymentMode,
                                                        ...getPaymentTypeStyle(item.paymentType)
                                                    }}>
                                                        {item.paymentType || "UPI"}
                                                    </span>
                                                </td>
                                                <td style={styles.partnerSettlementCell}>
                                                    <div style={{ maxWidth: '120px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                        {item.transactionId || '-'}
                                                    </div>
                                                </td>
                                                <td style={styles.partnerSettlementCell}>
                                                    <span style={{ ...styles.settlementBadge, ...getStatusBadge(item.settlementStatus) }}>
                                                        {item.settlementStatus}
                                                    </span>
                                                </td>
                                                <td style={styles.partnerSettlementCell}>
                                                    {item.settlementStatus !== "COMPLETED" && item.settlementStatus !== "PAID" ? (
                                                        <button
                                                            onClick={() => handleStatusUpdateClick(item)}
                                                            style={{
                                                                ...styles.partnerSettlementAction,
                                                                background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
                                                                color: 'white'
                                                            }}
                                                        >
                                                            Update
                                                        </button>
                                                    ) : (
                                                        <span style={{ color: '#48bb78', fontWeight: '600', fontSize: '11px' }}>
                                                            ✓ Completed
                                                        </span>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Update Status Modal */}
            {showUpdateModal && selectedSettlement && (
                <div style={styles.settlementModalOverlay} onClick={() => setShowUpdateModal(false)}>
                    <div style={styles.settlementModal} onClick={(e) => e.stopPropagation()}>
                        <div style={styles.settlementModalHeader}>
                            <h3 style={styles.settlementModalTitle}>
                                <Icons.Edit style={{ color: '#e66d33' }} /> Update Settlement Status
                            </h3>
                            <button style={styles.settlementModalClose} onClick={() => setShowUpdateModal(false)}>
                                <Icons.Close />
                            </button>
                        </div>

                        <div style={styles.settlementModalBody}>
                            <div style={styles.settlementFormRow}>
                                <div style={styles.settlementFormGroup}>
                                    <label style={styles.settlementLabel}>Settlement ID</label>
                                    <input
                                        type="text"
                                        value={selectedSettlement.id}
                                        readOnly
                                        style={styles.settlementReadOnlyInput}
                                    />
                                </div>
                                <div style={styles.settlementFormGroup}>
                                    <label style={styles.settlementLabel}>Partner ID</label>
                                    <input
                                        type="text"
                                        value={selectedSettlement.partnerId}
                                        readOnly
                                        style={styles.settlementReadOnlyInput}
                                    />
                                </div>
                            </div>

                            <div style={styles.settlementFormRow}>
                                <div style={styles.settlementFormGroup}>
                                    <label style={styles.settlementLabel}>Requested Amount (Original)</label>
                                    <input
                                        type="text"
                                        value={`₹${selectedSettlement.withdrawlAmount || 0}`}
                                        readOnly
                                        style={styles.settlementReadOnlyInput}
                                    />
                                </div>
                                <div style={styles.settlementFormGroup}>
                                    <label style={{ ...styles.settlementLabel, color: '#2196F3' }}>
                                        Settlement Amount *
                                    </label>
                                    <input
                                        type="number"
                                        value={amount}
                                        onChange={(e) => setAmount(e.target.value)}
                                        placeholder="Enter settlement amount"
                                        min="0"
                                        step="0.01"
                                        style={{
                                            width: '100%',
                                            padding: '10px 14px',
                                            borderRadius: '8px',
                                            border: '2px solid #2196F3',
                                            fontSize: '13px',
                                            outline: 'none',
                                            boxSizing: 'border-box',
                                            background: '#f8fdff'
                                        }}
                                        required
                                    />
                                    <small style={{ color: '#666', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                                        Enter the actual amount to be settled
                                    </small>
                                </div>
                            </div>

                            <div style={styles.settlementFormRow}>
                                <div style={styles.settlementFormGroup}>
                                    <label style={styles.settlementLabel}>Current Status</label>
                                    <div style={{ ...styles.settlementBadge, ...getStatusBadge(selectedSettlement.settlementStatus), fontSize: '14px', padding: '10px 16px', display: 'inline-block', width: '100%', textAlign: 'center', boxSizing: 'border-box' }}>
                                        {selectedSettlement.settlementStatus}
                                    </div>
                                </div>
                                <div style={styles.settlementFormGroup}>
                                    <label style={styles.settlementLabel}>Payment Type</label>
                                    <input
                                        type="text"
                                        value={selectedSettlement.paymentType || "UPI"}
                                        readOnly
                                        style={styles.settlementReadOnlyInput}
                                    />
                                </div>
                            </div>

                            <div style={styles.settlementFormGroupFull}>
                                <label style={{ ...styles.settlementLabel, color: '#2196F3' }}>
                                    Transaction ID *
                                </label>
                                <input
                                    type="text"
                                    value={transactionId}
                                    onChange={(e) => setTransactionId(e.target.value)}
                                    placeholder="Enter transaction/reference ID (Required)"
                                    required
                                    style={{
                                        width: '100%',
                                        padding: '10px 14px',
                                        borderRadius: '8px',
                                        border: `2px solid ${transactionId ? '#2196F3' : '#f44336'}`,
                                        fontSize: '13px',
                                        outline: 'none',
                                        boxSizing: 'border-box',
                                        background: transactionId ? '#f8fdff' : '#fff8f8'
                                    }}
                                />
                                <div style={{ marginTop: '8px', display: 'flex', gap: '10px', alignItems: 'center' }}>
                                    <button
                                        type="button"
                                        onClick={() => setTransactionId(generateTransactionId())}
                                        style={{
                                            padding: '6px 12px',
                                            backgroundColor: '#e3f2fd',
                                            border: '1px solid #2196F3',
                                            borderRadius: '4px',
                                            fontSize: '12px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        Generate Transaction ID
                                    </button>
                                    <small style={{ color: '#666', fontSize: '12px' }}>
                                        <strong>Required:</strong> Enter transaction ID or reference number
                                    </small>
                                </div>
                            </div>

                            {/* Admin Wallet Balance Check */}
                            <div style={styles.settlementFormGroupFull}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                    <label style={{ ...styles.settlementLabel, color: '#2196F3' }}>
                                        Admin Wallet Status
                                    </label>
                                    <button
                                        onClick={checkAdminWalletBalance}
                                        disabled={checkingBalance}
                                        style={{
                                            padding: '6px 12px',
                                            backgroundColor: checkingBalance ? '#cccccc' : '#2196F3',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: checkingBalance ? 'not-allowed' : 'pointer',
                                            fontSize: '12px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '5px'
                                        }}
                                    >
                                        {checkingBalance ? (
                                            <>
                                                <span style={{
                                                    display: 'inline-block',
                                                    width: '12px',
                                                    height: '12px',
                                                    border: '2px solid currentColor',
                                                    borderRightColor: 'transparent',
                                                    borderRadius: '50%',
                                                    animation: 'spinner-border .75s linear infinite'
                                                }}></span>
                                                Checking...
                                            </>
                                        ) : (
                                            'Check Balance'
                                        )}
                                    </button>
                                </div>

                                {walletBalance !== null && (
                                    <div style={{
                                        padding: '10px',
                                        backgroundColor: walletBalance >= parseFloat(amount) ? '#e8f5e9' : '#ffebee',
                                        borderRadius: '4px',
                                        border: `1px solid ${walletBalance >= parseFloat(amount) ? '#4caf50' : '#f44336'}`,
                                        fontSize: '14px'
                                    }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <span style={{ fontWeight: 'bold' }}>Available Balance:</span>
                                            <span style={{
                                                fontWeight: 'bold',
                                                color: walletBalance >= parseFloat(amount) ? '#2e7d32' : '#c62828',
                                                fontSize: '16px'
                                            }}>
                                                ₹{walletBalance.toFixed(2)}
                                            </span>
                                        </div>

                                        <div style={{ marginTop: '8px', fontSize: '12px' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <span>Settlement Amount:</span>
                                                <span>₹{parseFloat(amount).toFixed(2)}</span>
                                            </div>
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                marginTop: '4px',
                                                fontWeight: 'bold'
                                            }}>
                                                <span>Remaining After Settlement:</span>
                                                <span style={{
                                                    color: (walletBalance - parseFloat(amount)) >= 0 ? '#2e7d32' : '#c62828'
                                                }}>
                                                    ₹{(walletBalance - parseFloat(amount)).toFixed(2)}
                                                </span>
                                            </div>
                                        </div>

                                        {walletBalance < parseFloat(amount) && (
                                            <div style={{
                                                marginTop: '10px',
                                                padding: '8px',
                                                backgroundColor: '#fff3cd',
                                                border: '1px solid #ffeaa7',
                                                borderRadius: '4px',
                                                fontSize: '12px',
                                                color: '#856404'
                                            }}>
                                                ⚠️ <strong>Warning:</strong> Insufficient balance for this settlement.
                                                {walletBalance > 0 ? (
                                                    <div style={{ marginTop: '4px' }}>
                                                        You can only settle up to ₹{walletBalance.toFixed(2)}.
                                                    </div>
                                                ) : (
                                                    <div style={{ marginTop: '4px' }}>
                                                        Admin wallet has no funds. Please add funds first.
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                )}

                                {walletBalance === null && !checkingBalance && (
                                    <div style={{
                                        padding: '10px',
                                        backgroundColor: '#f5f5f5',
                                        borderRadius: '4px',
                                        border: '1px solid #ddd',
                                        fontSize: '12px',
                                        color: '#666',
                                        textAlign: 'center'
                                    }}>
                                        Click "Check Balance" to view available funds
                                    </div>
                                )}
                            </div>

                            <div style={styles.settlementModalFooter}>
                                <button
                                    onClick={() => {
                                        setShowUpdateModal(false);
                                        setSelectedSettlement(null);
                                        setNewStatus("");
                                        setTransactionId("");
                                        setAmount("");
                                        setWalletBalance(null);
                                    }}
                                    style={{ ...styles.settlementButton, ...styles.settlementButtonSecondary, flex: 1 }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleUpdateStatus}
                                    style={{ ...styles.settlementButton, ...styles.settlementButtonPrimary, flex: 1 }}
                                >
                                    Update Status
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

// ============================================
// MAIN COMPONENT - Foodsettlementpage
// ============================================
const Foodsettlementpage = () => {
    const [searchType, setSearchType] = useState("partnerId");
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedDate, setSelectedDate] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [dateFilterType, setDateFilterType] = useState("all");
    const [customStartDate, setCustomStartDate] = useState("");
    const [customEndDate, setCustomEndDate] = useState("");

    const searchOptions = [
        { value: "partnerId", label: "Partner ID" },
        { value: "id", label: "Settlement ID" },
        { value: "transactionId", label: "Transaction ID" },
        { value: "partnerUpiId", label: "UPI ID" },
        { value: "partnerBankAccountNumber", label: "Bank Account" },
        { value: "partnerAccountHolderName", label: "Account Holder" }
    ];

    const statusOptions = [
        { value: "", label: "All Status" },
        { value: "COMPLETED", label: "Completed" },
        { value: "PENDING", label: "Pending" },
        { value: "REJECTED", label: "Rejected" }
    ];

    const [settlements, setSettlements] = useState([]);
    const [partnerGroups, setPartnerGroups] = useState({});
    const [filteredPartnerGroups, setFilteredPartnerGroups] = useState({});

    const { showLoader, hideLoader } = useLoader();

    useEffect(() => {
        fetchSettlements();
    }, []);

    const fetchSettlements = async () => {
        try {
            showLoader();
            const data = await getAllDeliverySettlementsAPI();
            setSettlements(data);
            groupByPartner(data);
        } catch (err) {
            console.error("Error fetching settlements:", err);
        } finally {
            hideLoader();
        }
    };

    const groupByPartner = (data) => {
        const grouped = data.reduce((acc, item) => {
            const partnerId = item.partnerId;
            if (!acc[partnerId]) {
                acc[partnerId] = [];
            }
            acc[partnerId].push(item);
            return acc;
        }, {});
        setPartnerGroups(grouped);
        setFilteredPartnerGroups(grouped);
    };

    const getPlaceholderText = () => {
        switch (searchType) {
            case "partnerId": return "Search Partner ID...";
            case "id": return "Search Settlement ID...";
            case "transactionId": return "Search Transaction ID...";
            case "partnerUpiId": return "Search UPI ID...";
            case "partnerBankAccountNumber": return "Search Bank Account...";
            case "partnerAccountHolderName": return "Search Account Holder...";
            default: return "Search...";
        }
    };

    // Date filter logic
    const applyDateFilter = (data) => {
        if (dateFilterType === "all") return data;

        const now = new Date();
        let startDate = new Date();
        let endDate = new Date();

        switch (dateFilterType) {
            case "today":
                startDate = new Date(now.setHours(0, 0, 0, 0));
                endDate = new Date(now.setHours(23, 59, 59, 999));
                break;
            case "week":
                const day = now.getDay();
                startDate = new Date(now);
                startDate.setDate(now.getDate() - day);
                startDate.setHours(0, 0, 0, 0);
                endDate = new Date(now);
                endDate.setDate(now.getDate() + (6 - day));
                endDate.setHours(23, 59, 59, 999);
                break;
            case "month":
                startDate = new Date(now.getFullYear(), now.getMonth(), 1);
                endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
                break;
            case "custom":
                if (customStartDate && customEndDate) {
                    startDate = new Date(customStartDate);
                    endDate = new Date(customEndDate);
                    endDate.setHours(23, 59, 59, 999);
                } else {
                    return data;
                }
                break;
            default:
                return data;
        }

        return data.filter(item => {
            const settlementDate = new Date(item.settlementRequestDate || item.settlementDate);
            return settlementDate >= startDate && settlementDate <= endDate;
        });
    };

    const applyFilters = useMemo(() => {
        let filtered = { ...partnerGroups };

        // Search filter
        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();
            const filteredKeys = Object.keys(filtered).filter(partnerId => {
                const items = filtered[partnerId];
                return items.some(item => {
                    const fieldValue = item[searchType];
                    return fieldValue && fieldValue.toString().toLowerCase().includes(query);
                });
            });
            filtered = Object.fromEntries(
                Object.entries(filtered).filter(([key]) => filteredKeys.includes(key))
            );
        }

        // Status filter
        if (statusFilter) {
            const filteredKeys = Object.keys(filtered).filter(partnerId => {
                const items = filtered[partnerId];
                return items.some(item => item.settlementStatus === statusFilter);
            });
            filtered = Object.fromEntries(
                Object.entries(filtered).filter(([key]) => filteredKeys.includes(key))
            );
        }

        // Date filter
        const dateFiltered = Object.fromEntries(
            Object.entries(filtered).map(([partnerId, items]) => {
                const filteredItems = applyDateFilter(items);
                return [partnerId, filteredItems];
            }).filter(([_, items]) => items.length > 0)
        );

        return dateFiltered;
    }, [partnerGroups, searchQuery, searchType, statusFilter, dateFilterType, customStartDate, customEndDate]);

    useEffect(() => {
        setFilteredPartnerGroups(applyFilters);
    }, [applyFilters]);

    const clearAllFilters = () => {
        setSearchQuery("");
        setSelectedDate("");
        setStatusFilter("");
        setDateFilterType("all");
        setCustomStartDate("");
        setCustomEndDate("");
    };

    const handleExport = () => {
        const allItems = Object.values(partnerGroups).flat();
        if (allItems.length === 0) {
            alert("No data available for export.");
            return;
        }

        const headers = ["ID", "Partner ID", "Withdrawal Amount", "Request Date", "Settlement Date", "Payment Type", "Status", "Transaction ID", "UPI ID", "Bank Account", "IFSC", "Bank Name", "Account Holder"];
        const rows = allItems.map((it) => [
            it.id,
            it.partnerId,
            it.withdrawlAmount,
            it.settlementRequestDate ? formatDate(it.settlementRequestDate) : "-",
            it.settlementDate || "-",
            it.paymentType || "UPI",
            it.settlementStatus,
            it.transactionId || "-",
            it.partnerUpiId || "-",
            it.partnerBankAccountNumber || "-",
            it.partnerIfscCode || "-",
            it.partnerBankName || "-",
            it.partnerAccountHolderName || "-"
        ]);

        const csvContent = [headers, ...rows].map(r => r.join(",")).join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `partner_settlements_${new Date().toISOString().split('T')[0]}.csv`;
        link.click();
    };

    const formatDate = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        return date.toISOString().split("T")[0];
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return "-";
        try {
            const date = new Date(dateString);
            return date.toLocaleString();
        } catch (error) {
            return dateString;
        }
    };

    const getStatusBadge = (status) => {
        if (!status) return styles.settlementBadgeDefault;
        if (status === "PAID" || status === "COMPLETED") return styles.settlementBadgeCompleted;
        if (status === "PENDING") return styles.settlementBadgePending;
        if (status === "REJECTED") return styles.settlementBadgeRejected;
        return styles.settlementBadgeDefault;
    };

    const getPaymentTypeStyle = (type) => {
        switch (type) {
            case "UPI": return styles.paymentTypeUPI;
            case "BANK_TRANSFER": return styles.paymentTypeBank;
            case "NEFT": return styles.paymentTypeNEFT;
            case "RTGS": return styles.paymentTypeRTGS;
            default: return styles.paymentTypeDefault;
        }
    };

    // Calculate overall stats
    const allItems = Object.values(partnerGroups).flat();
    const totalSettlements = allItems.length;
    const totalAmount = allItems.reduce((sum, item) => sum + (item.withdrawlAmount || 0), 0);
    const completedCount = allItems.filter(item => item.settlementStatus === "COMPLETED" || item.settlementStatus === "PAID").length;
    const pendingCount = allItems.filter(item => item.settlementStatus === "PENDING").length;
    const rejectedCount = allItems.filter(item => item.settlementStatus === "REJECTED").length;
    const totalPartners = Object.keys(partnerGroups).length;

    return (
        <div className="settlement-wrapper" style={styles.settlementContainer}>
            {/* Header */}


            {/* Stats Grid */}
            <div style={styles.settlementStatsGrid}>
                <div style={styles.settlementStatCard}>
                    <div style={styles.settlementStatValue}>{totalPartners}</div>
                    <div style={styles.settlementStatLabel}>Total Partners</div>
                </div>
                <div style={styles.settlementStatCard}>
                    <div style={styles.settlementStatValue}>{totalSettlements}</div>
                    <div style={styles.settlementStatLabel}>Total Settlements</div>
                </div>
                <div style={styles.settlementStatCard}>
                    <div style={{ ...styles.settlementStatValue, color: '#28a745' }}>
                        {(totalAmount)}
                    </div>
                    <div style={styles.settlementStatLabel}>Total Amount</div>
                </div>
                <div style={styles.settlementStatCard}>
                    <div style={{ ...styles.settlementStatValue, color: '#28a745' }}>
                        {completedCount}
                    </div>
                    <div style={styles.settlementStatLabel}>Completed</div>
                </div>
                <div style={styles.settlementStatCard}>
                    <div style={{ ...styles.settlementStatValue, color: '#ffc107' }}>
                        {pendingCount}
                    </div>
                    <div style={styles.settlementStatLabel}>Pending</div>
                </div>
                {rejectedCount > 0 && (
                    <div style={styles.settlementStatCard}>
                        <div style={{ ...styles.settlementStatValue, color: '#dc3545' }}>
                            {rejectedCount}
                        </div>
                        <div style={styles.settlementStatLabel}>Rejected</div>
                    </div>
                )}
            </div>

            {/* Date Filter Section */}
            <div style={styles.dateFilterSection}>
                <span style={{ fontWeight: '600', fontSize: '13px', color: '#4a5568' }}>📅 Date Range:</span>
                <button
                    style={{
                        ...styles.dateFilterButton,
                        ...(dateFilterType === 'all' ? styles.dateFilterButtonActive : {})
                    }}
                    onClick={() => setDateFilterType('all')}
                >
                    All
                </button>
                <button
                    style={{
                        ...styles.dateFilterButton,
                        ...(dateFilterType === 'today' ? styles.dateFilterButtonActive : {})
                    }}
                    onClick={() => setDateFilterType('today')}
                >
                    Today
                </button>
                <button
                    style={{
                        ...styles.dateFilterButton,
                        ...(dateFilterType === 'week' ? styles.dateFilterButtonActive : {})
                    }}
                    onClick={() => setDateFilterType('week')}
                >
                    This Week
                </button>
                <button
                    style={{
                        ...styles.dateFilterButton,
                        ...(dateFilterType === 'month' ? styles.dateFilterButtonActive : {})
                    }}
                    onClick={() => setDateFilterType('month')}
                >
                    This Month
                </button>
                <button
                    style={{
                        ...styles.dateFilterButton,
                        ...(dateFilterType === 'custom' ? styles.dateFilterButtonActive : {})
                    }}
                    onClick={() => setDateFilterType('custom')}
                >
                    Custom
                </button>
                {dateFilterType === 'custom' && (
                    <>
                        <span style={styles.dateFilterDivider}>|</span>
                        <input
                            type="date"
                            value={customStartDate}
                            onChange={(e) => setCustomStartDate(e.target.value)}
                            style={styles.settlementDateInput}
                            placeholder="Start Date"
                        />
                        <span style={{ color: '#718096' }}>to</span>
                        <input
                            type="date"
                            value={customEndDate}
                            onChange={(e) => setCustomEndDate(e.target.value)}
                            style={styles.settlementDateInput}
                            placeholder="End Date"
                        />
                    </>
                )}
            </div>

            {/* Filters */}
            <div style={styles.settlementFilters}>
                <div style={styles.settlementSearchGroup}>
                    <div style={{ position: 'relative', flex: 1 }}>
                        <input
                            type="text"
                            placeholder={getPlaceholderText()}
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            style={{
                                ...styles.settlementSearchInput,
                                borderColor: searchQuery ? '#e66d33' : '#e2e8f0'
                            }}
                            onFocus={(e) => {
                                e.target.style.borderColor = '#e66d33';
                                e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
                            }}
                            onBlur={(e) => {
                                e.target.style.borderColor = '#e2e8f0';
                                e.target.style.boxShadow = 'none';
                            }}
                        />
                    </div>
                </div>

                <select
                    value={searchType}
                    onChange={(e) => setSearchType(e.target.value)}
                    style={styles.settlementSelect}
                >
                    {searchOptions.map(option => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>

                <select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    style={{ ...styles.settlementSelect, minWidth: '130px' }}
                >
                    {statusOptions.map(option => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>

                <button onClick={clearAllFilters} style={{ ...styles.settlementButton, ...styles.settlementButtonSecondary }}>
                    <Icons.Clear /> Clear
                </button>

                <button onClick={fetchSettlements} style={{ ...styles.settlementButton, ...styles.settlementButtonPrimary }}>
                    <Icons.Refresh /> Refresh
                </button>
                <button onClick={handleExport} style={{ ...styles.settlementButton, ...styles.settlementButtonExport }}>
                    <Icons.Export /> Export All
                </button>
            </div>

            {/* Partner Dashboard Cards */}
            {Object.keys(filteredPartnerGroups).length > 0 ? (
                <div style={styles.partnerDashboardGrid}>
                    {Object.entries(filteredPartnerGroups).map(([partnerId, partnerData]) => (
                        <PartnerDashboardCard
                            key={partnerId}
                            partnerId={partnerId}
                            partnerData={partnerData}
                            onUpdateStatus={fetchSettlements}
                        />
                    ))}
                </div>
            ) : (
                <div style={styles.settlementEmptyState}>
                    <Icons.NoData />
                    <div style={styles.settlementEmptyStateText}>
                        {settlements.length === 0 ? 'Loading settlements...' : 'No partners found'}
                    </div>
                    <div style={styles.settlementEmptyStateSubtext}>
                        {settlements.length === 0
                            ? 'Please wait while we fetch the data'
                            : (searchQuery.trim() || statusFilter || dateFilterType !== 'all')
                                ? 'Try adjusting your filters to see more results'
                                : 'No settlements are available'}
                    </div>
                </div>
            )}

            <style>{`
                @keyframes settlementSlideUp {
                    from { opacity: 0; transform: translateY(30px) scale(0.95); }
                    to { opacity: 1; transform: translateY(0) scale(1); }
                }

                @keyframes settlementFadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }

                @keyframes slideDown {
                    from {
                        opacity: 0;
                        transform: translateY(-10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @keyframes spinner-border {
                    to { transform: rotate(360deg); }
                }

                .settlement-wrapper {
                    animation: settlementFadeIn 0.4s ease;
                }

                .partner-card-header:hover {
                    filter: brightness(1.05);
                }

                .kpi-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
                }

                ::-webkit-scrollbar {
                    width: 8px;
                    height: 8px;
                }
                ::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 4px;
                }
                ::-webkit-scrollbar-thumb {
                    background: linear-gradient(135deg, #e66d33 0%, #d45a2a 100%);
                    border-radius: 4px;
                }
                ::-webkit-scrollbar-thumb:hover {
                    background: linear-gradient(135deg, #d45a2a 0%, #b84a1a 100%);
                }

                /* Mobile Responsive */
                @media (max-width: 1024px) {
                    .settlement-container {
                        max-width: 95% !important;
                        padding: 10px !important;
                    }
                    .kpi-grid {
                        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)) !important;
                    }
                    .partner-details-grid {
                        grid-template-columns: 1fr !important;
                    }
                }

                @media (max-width: 768px) {
                    .settlement-container {
                        max-width: 100% !important;
                        padding: 8px !important;
                    }
                    .settlement-filters {
                        flex-direction: column !important;
                        align-items: stretch !important;
                    }
                    .settlement-search-group {
                        min-width: unset !important;
                        flex-direction: column !important;
                    }
                    .settlement-stats-grid {
                        grid-template-columns: repeat(3, 1fr) !important;
                        gap: 8px !important;
                        padding: 12px !important;
                    }
                    .settlement-stat-value {
                        font-size: 18px !important;
                    }
                    .settlement-stat-label {
                        font-size: 10px !important;
                    }
                    .partner-card-header {
                        padding: 12px 16px !important;
                    }
                    .partner-header-name {
                        font-size: 15px !important;
                    }
                    .partner-dashboard-body {
                        padding: 12px !important;
                    }
                    .kpi-grid {
                        grid-template-columns: repeat(2, 1fr) !important;
                        gap: 8px !important;
                    }
                    .kpi-value {
                        font-size: 18px !important;
                    }
                    .partner-details-grid {
                        grid-template-columns: 1fr !important;
                    }
                    .date-filter-section {
                        flex-wrap: wrap !important;
                        gap: 6px !important;
                        padding: 10px !important;
                    }
                    .date-filter-button {
                        font-size: 10px !important;
                        padding: 4px 10px !important;
                    }
                    .settlement-modal {
                        width: 98% !important;
                        padding: 16px !important;
                    }
                    .settlement-form-row {
                        grid-template-columns: 1fr !important;
                        gap: 10px !important;
                    }
                    .partner-settlement-table {
                        font-size: 10px !important;
                    }
                    .partner-settlement-cell {
                        padding: 4px 6px !important;
                        font-size: 10px !important;
                    }
                    .partner-settlement-header {
                        font-size: 8px !important;
                        padding: 4px 6px !important;
                    }
                    .settlement-badge {
                        font-size: 8px !important;
                        padding: 2px 6px !important;
                    }
                }

                @media (max-width: 480px) {
                    .settlement-container {
                        padding: 4px !important;
                    }
                    .settlement-stats-grid {
                        grid-template-columns: repeat(2, 1fr) !important;
                    }
                    .kpi-grid {
                        grid-template-columns: 1fr 1fr !important;
                    }
                    .settlement-header {
                        flex-direction: column !important;
                        align-items: flex-start !important;
                    }
                    .partner-header-right {
                        width: 100% !important;
                        justify-content: flex-start !important;
                    }
                    .partner-header-stat {
                        font-size: 10px !important;
                        padding: 2px 8px !important;
                    }
                    .settlement-modal {
                        padding: 12px !important;
                    }
                    .settlement-modal-title {
                        font-size: 16px !important;
                    }
                    .partner-avatar {
                        width: 36px !important;
                        height: 36px !important;
                        font-size: 18px !important;
                    }
                }
            `}</style>
        </div>
    );
};

export default Foodsettlementpage;